import { Consolidation, Package } from '@returnmates/client-core/src/graphql/generated/api'
import { getConsolidationPackages } from '@returnmates/client-core/src/selectors/packages'
import { Dispatch, memo, SetStateAction, useCallback } from 'react'
import { useSelector } from 'react-redux'

import DetailsSection from '../../../components/DetailsSection'
import PlusIcon from '../../../components/images/icons/plus'
import PackagesTable from '../../../components/PackagesTable'
import useStyles from '../styles'

interface Props {
  row: Consolidation & { date: string }
  setPackageToRemove?: ({
    consolidationId,
    consolidationPackageId,
  }: {
    consolidationId: string
    consolidationPackageId?: string
  }) => void
  onEditPackageClick?: (params: Package) => void
  setIsNewPackageModalOpen: Dispatch<SetStateAction<boolean>>
  setIsRemovePackageModalOpen: Dispatch<SetStateAction<boolean>>
  isOuterLoading?: boolean
  packagesCount?: number
  currentPackagePageSize?: number
  onCurrentPagePackageSize: Dispatch<SetStateAction<number>>
  setCurrentPackagePage: Dispatch<SetStateAction<number>>
  currentPackagePage?: number
}

function PickupDetails({
  row,
  setIsNewPackageModalOpen,
  setIsRemovePackageModalOpen,
  onEditPackageClick: onEditPackageClickProps,
  setPackageToRemove,
  isOuterLoading,
  packagesCount,
  setCurrentPackagePage,
  currentPackagePage,
  currentPackagePageSize,
  onCurrentPagePackageSize,
}: Props) {
  const classes = useStyles()
  const packages = useSelector(getConsolidationPackages)

  const onEditPackageClick = useCallback(
    (row: Package) => {
      onEditPackageClickProps?.(row)
    },
    [onEditPackageClickProps],
  )

  const onRemovePackage = useCallback(
    id => {
      const currentPackage = packages?.find(p => p.id === id)

      setIsRemovePackageModalOpen(true)
      setPackageToRemove?.({
        consolidationId: row.id,
        consolidationPackageId: currentPackage?.id,
      })
    },
    [packages, row.id, setIsRemovePackageModalOpen, setPackageToRemove],
  )

  const openNewPackageModal = useCallback(() => {
    setIsNewPackageModalOpen(true)
  }, [setIsNewPackageModalOpen])

  return (
    <div className={classes.packagesInfo}>
      <DetailsSection
        className={classes.packagesTable}
        sectionTitle="Packages"
        icon={PlusIcon}
        onIconClick={openNewPackageModal}
      >
        <PackagesTable
          packages={packages || []}
          showToolbar={false}
          canDeleteRow
          editOnRowClick
          setEditableRow={onEditPackageClick}
          onRemovePackage={onRemovePackage}
          canSelectRow={false}
          isLoading={isOuterLoading}
          showPaging
          totalCount={packagesCount}
          onCurrentPageChange={setCurrentPackagePage}
          currentPageNumber={currentPackagePage}
          onPageSizeChange={onCurrentPagePackageSize}
          currentPackagePageSize={currentPackagePageSize}
        />
      </DetailsSection>
    </div>
  )
}

export default memo(PickupDetails)
